import React, { useCallback, useContext, useEffect, useState } from "react";
import SomaPlaceService from "../Services/SomaPlace/index";
import useUser from "./UserContext";

const SomaPlaceUserContext = React.createContext();

const useSomaPlaceUser = () => {
  return useContext(SomaPlaceUserContext);
};

const SomaPlaceUserContextProvider = (props) => {
  const user = useUser();
  const [accessSomaPlace, setAccessSomaPlace] = useState(undefined);
  const [status, setStatus] = useState("ready");
  const [requestStatus, setRequestStatus] = useState(undefined);
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(undefined);
  if (error) {
  }
  const api = SomaPlaceService.SomaPlace.fetchInfo;
  const apiBank = SomaPlaceService.SomaPlace.fetchBanckDataUser;
  const updateSomaPlaceUser = useCallback(async () => {
    setStatus("pending");
    try {
      const res = await api();
      try {
        const bankData = await apiBank(res.data.user);
        res.data.user.bankData = bankData.data;
      } catch (error) {
        //pass
        console.log("erro", error);
      }
      setStatus("ready");
      setData(res);
      return res;
    } catch (error) {
      setStatus("ready");
      setError(error.message);
      setRequestStatus(404);
    }
  }, [api, apiBank]);
  const checkAccessSomaPlace = useCallback(async () => {
    const r = await SomaPlaceService.SomaPlace.checkAccessSomaPlace();
    if (r.data) {
      if (r.data.isTester || r.data.open) {
        setAccessSomaPlace(true);
      }
    }
  }, []);

  useEffect(() => {
    if (user) {
      checkAccessSomaPlace();
    } else {
      setAccessSomaPlace(false)
    }
  }, [checkAccessSomaPlace, user]);

  const getSomaPlaceUser = async () => {
    let somaPlaceUser = await updateSomaPlaceUser();
    return somaPlaceUser;
  }

  useEffect(() => {
    if (user && !data) {
      updateSomaPlaceUser();
    }
    if (data) {
      setRequestStatus(data.status);
    }
    //  const interval = setInterval(updateAffiliate, 30000);
    //  return () => clearInterval(interval);
  }, [user, updateSomaPlaceUser, data]);

  return (
    <SomaPlaceUserContext.Provider
      value={{
        somaPlaceUser: data?.data.user,
        status: requestStatus,
        fetchStatus: status,
        latestContract: data?.data.latestContract,
        signature: data?.data.signature,
        setSomaPlaceUser: setData,
        updateSomaPlaceUser,
        accessSomaPlace,
        getSomaPlaceUser
      }}
    >
      {props.children}
    </SomaPlaceUserContext.Provider>
  );
};

export { SomaPlaceUserContextProvider };
export default useSomaPlaceUser;
